module.exports = "<div class=\"text-center  position-bottom mx-0 my-0\">\n  <h1>Footer works</h1>\n</div>"